const API = {
    GET_SELECTNEW_INFO: '/drep/selectnewinfo.do',
    get_drepkline:'/drep/drepkline.do',
    get_drepticker:'/drep/drepticker.do',
    get_ipcountryinfo:'/drep/queryipcountryinfo.do',

}

export default API